import { createStore } from 'vuex'

import user from './Modules/User';
import task from './Modules/Task';
import taskWork from './Modules/TaskWork';
import project from './Modules/Project';
import localUserlist from './Modules/LocalUserList';
import updatesPage from './Modules/UpdatesPage';
import person from './Modules/Person';
import report from './Modules/Report';
import otherWork from './Modules/OtherWork';
import reminder from './Modules/Reminder';
import taskType from './Modules/TaskType';
import otherWorkType from './Modules/OtherWorkType';
import taskNote from './Modules/TaskNote';
import orgJob from './Modules/OrgJob';
import checkList from './Modules/CheckList';
import userPresence from './Modules/UserPresence';
import docPin from './Modules/DocPin';
import InviteUserListPage from './Modules/InviteUserListPage';
import InviteUserPage from './Modules/InviteUserPage';
import Meeting from './Modules/Meeting';
import NoticeMessage from './Modules/NoticeMessage';
import WorkTimer from './Modules/WorkTimer';



export const store = createStore({
  state: {},
  modules: {
     user,
      task,
      taskWork,
      project,
      localUserlist,
      person,
      report,
      otherWork,
      updatesPage,
      InviteUserListPage,
      InviteUserPage,
      reminder,
      taskType,
      otherWorkType,
      orgJob,
      taskNote,
      checkList,
      userPresence,
      docPin,
      Meeting,
      NoticeMessage,
      WorkTimer
  }
});
